import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import Vant from 'vant';
import 'vant/lib/index.css';
// 1. 引入AOS核心JS
import AOS from 'aos'
// 2. 引入AOS默认样式（必须引入，否则无动画效果）
import 'aos/dist/aos.css'
import '@/style/font.css'
// 3. 初始化AOS（可传入全局配置，可选）
AOS.init({
  duration: 800, // 动画持续时间（毫秒）
  easing: 'ease-out', // 动画缓动函数
  delay: 0, // 动画延迟时间
  once: true, // 是否只触发一次动画（滚动回滚时不再重复触发，推荐开启）
  offset: 100 // 元素距离可视区域底部100px时触发动画（对应手动实现的阈值）
})
// 判断是否为手机端函数
function isMobile() {   //判断是否为移动端
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile/.test(userAgent);
}
// 引入 SvgIcon 组件
import SvgIcon from './components/SvgIcon.vue'
// 全局注册
Vue.component('SvgIcon', SvgIcon)
Vue.use(ElementUI);
Vue.use(Vant);
Vue.prototype.$isMobile = isMobile()

Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
